export default "__VITE_ASSET__BW3edgQ6__"